import { useNativeBridge } from './useNativeBridge';

export namespace UBIKey {}

/**
 * 유비키 처리 네이티브 브릿지 hook 함수
 */
const useUBIKeyBridge = () => {
    const nativeBridge = useNativeBridge();

    /**
     * 유비키 상태 요청
     */
    const doNUBIKeyStatus = async () => {
        const res = await nativeBridge<void, { result: string }>('doNUBIKeyStatus');
        const { status, payload } = res;

        if (status === 'fail') {
            return;
        }

        if (!payload) {
            return;
        }

        return payload.result;
    };

    /**
     * ubiKey 인증서 저장
     * @param index
     * @param serial
     * @returns
     */
    const doNUBIKeyCertSave = async (index: number, serial: string) => {
        const res = await nativeBridge<{ index: number; serial: string }, { result: string }>(
            'doNUBIKeyCertSave',
            {
                index,
                serial,
            },
        );
        const { status, payload } = res;

        if (status === 'fail') {
            return;
        }

        if (!payload) {
            return;
        }

        return payload.result;
    };

    /**
     * ubiKey 가입요청
     */
    const doNUBIKeyJoin = async () => {
        const res = await nativeBridge<void, { result: string }>('doNUBIKeyJoin');
        const { status, payload } = res;

        if (status === 'fail') {
            return;
        }

        if (!payload) {
            return;
        }

        return payload.result;
    };

    /**
     * 유비키 체크(login에서 사용)
     * @param type 0: login, 1: sign
     * @returns
     */
    const doNUbiKeyGetCert = async (type: '0' | '1') => {
        const res = await nativeBridge<{ type: '0' | '1' }, { result: string; certId: string }>(
            'doNUBIKeyGetCert',
            {
                type,
            },
            {
                timeoutMillis: -1,
            }
        );
        const { status, payload } = res;

        if (status === 'fail' || !payload) {
            return;
        }

        return payload;
    };

    return {
        doNUBIKeyStatus,
        doNUBIKeyCertSave,
        doNUBIKeyJoin,
        doNUbiKeyGetCert,
    };
};

export { useUBIKeyBridge };
